export enum BathCardVariant {
	Barcode = 'BarcodeCard',
	Summary = 'SummaryCard',
}
